export default "__VITE_ASSET__Dof_zcqz__"